import { render } from "./post-config.vue?vue&type=template&id=22cd1481&scoped=true"
import script from "./post-config.vue?vue&type=script&lang=js"
export * from "./post-config.vue?vue&type=script&lang=js"

import "./post-config.vue?vue&type=style&index=0&id=22cd1481&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cd1481"]])

export default __exports__